import { FormFieldModel } from './form-field.model';
import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';
import { TemplateRef, Type } from '@angular/core';
import { StyleTypesApiEnum } from '../../../api/styles/enum/style-types-api.enum';
import { TextStyleDefaultsModel } from './text-style-defaults.model';
import { StyleStateEnum } from '../enums/style-state.enum';
import { DropdownOptionModel } from '../../../Common/Forms/models/dropdown-option.model';

export class TextStyleFieldModel implements FormFieldModel {
    property: string;
    isPrimary: boolean;
    defaults: TextStyleDefaultsModel;
    label?: string;
    showStyleState?: boolean;
    showAlignmentButtons: boolean;
    showFontSizeDropdown: boolean;
    styleType?: StyleTypesApiEnum;
    fieldComponent?: Type<AbstractFormFieldComponent>;
    description?: string;
    showBackgroundColor?: boolean;
    allowExpertMode?: boolean;
    defaultStyleStateOptions: any[] = [
        { label: 'PageBuilder.formField.styles.defaultAgilityStyle', value: StyleStateEnum.DEFAULT },
        { label: 'PageBuilder.formField.styles.custom', value: StyleStateEnum.CUSTOM }
    ];
    changeDefaultStyleStateOptions: (x: any) => DropdownOptionModel[];

    customBackgroundColorTemplate?: TemplateRef<any>;

    constructor(
        property: string,
        isPrimary: boolean = true,
        defaults: TextStyleDefaultsModel,
        label?: string,
        showStyleState?: boolean,
        showAlignmentButtons: boolean = true,
        showFontSizeDropdown: boolean = true,
        styleType?: StyleTypesApiEnum,
        fieldComponent?: Type<AbstractFormFieldComponent>,
        description?: string,
        showBackgroundColor: boolean = false,
        allowExpertMode: boolean = true,
        defaultStyleStateOptions?: any[],
        changeDefaultStyleStateOptions?: (x: any) => DropdownOptionModel[]
    ) {
        this.property = property;
        this.isPrimary = isPrimary;
        this.defaults = defaults;
        this.label = label;
        this.showStyleState = showStyleState;
        this.showAlignmentButtons = showAlignmentButtons;
        this.showFontSizeDropdown = showFontSizeDropdown;
        this.styleType = styleType;
        this.fieldComponent = fieldComponent;
        this.description = description;
        this.showBackgroundColor = showBackgroundColor;
        this.allowExpertMode = allowExpertMode;
        if (defaultStyleStateOptions) {
            this.defaultStyleStateOptions = defaultStyleStateOptions;
        }
        this.changeDefaultStyleStateOptions = changeDefaultStyleStateOptions;
    }
}
